import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiInputGroupComponent } from './eui-input-group.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiInputGroupComponent,
    ],
    exports: [
        EuiInputGroupComponent,
    ],
})
export class EuiInputGroupModule { }
